/**
 * Product Dimensions Handler
 * Manages dynamic display of variant-specific furniture dimensions
 */

class ProductDimensions {
  constructor() {
    this.container = document.querySelector('[data-product-dimensions]');
    if (!this.container) return;

    this.contentWrapper = this.container.querySelector('.product-dimensions__content');
    this.variantData = {};
    
    this.init();
  }

  init() {
    this.buildVariantData();
    this.attachEventListeners();
  }

  buildVariantData() {
  const productJson = document.querySelector('[data-product-json]');
  if (!productJson) {
    console.error('ProductDimensions: Product JSON not found!');
    return;
  }

  try {
    const product = JSON.parse(productJson.textContent);
    console.log('ProductDimensions: Product data:', product);
    
    // Store product-level dimensions as fallback
    this.productLevelDimensions = product.productLevelDimensions || {};
    console.log('ProductDimensions: Product-level dimensions:', this.productLevelDimensions);
    
    product.variants.forEach(variant => {
      // Use variant dimensions if available, otherwise fall back to product dimensions
      this.variantData[variant.id] = {
        length: variant.metafields?.furniture?.length || this.productLevelDimensions.length || null,
        width: variant.metafields?.furniture?.width || this.productLevelDimensions.width || null,
        depth: variant.metafields?.furniture?.depth || this.productLevelDimensions.depth || null,
        height: variant.metafields?.furniture?.height || this.productLevelDimensions.height || null,
        diameter: variant.metafields?.furniture?.diameter || this.productLevelDimensions.diameter || null
      };
    });
    
    console.log('ProductDimensions: Variant data with fallbacks:', this.variantData);
  } catch (error) {
    console.error('ProductDimensions: Error parsing product data:', error);
  }
}

  attachEventListeners() {
    const variantSelectors = document.querySelectorAll('[name="id"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        this.handleVariantChange(e.target.value);
      });
    });

    const optionInputs = document.querySelectorAll(
      '.product-form__input input[type="radio"], .product-form__input select'
    );
    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        setTimeout(() => {
          const variantId = document.querySelector('[name="id"]')?.value;
          if (variantId) this.handleVariantChange(variantId);
        }, 50);
      });
    });

    document.addEventListener('shopify:section:load', () => {
      this.init();
    });

    document.addEventListener('variant:change', (event) => {
      if (event.detail?.variant?.id) {
        this.handleVariantChange(event.detail.variant.id);
      }
    });
  }

  handleVariantChange(variantId) {
    const dimensions = this.variantData[variantId];
    if (!dimensions) {
      this.contentWrapper.innerHTML = '';
      return;
    }

    this.updateDisplay(dimensions);
  }

updateDisplay(dimensions) {
  const hasDimensions = Object.values(dimensions).some(val => val !== null);
  
  if (!hasDimensions) {
    console.log('ProductDimensions: No dimensions to display');
    this.contentWrapper.innerHTML = '';
    return;
  }

  const dimensionLabels = this.getDimensionLabels();
  let html = '<div class="dimensions-list">';

  Object.entries(dimensions).forEach(([key, value]) => {
    if (value) {
      console.log(`ProductDimensions: Processing ${key}:`, value);
      
      // Dimension metafields come as complete strings like "403.0 mm"
      let displayValue = '';
      if (typeof value === 'string') {
        displayValue = value;
      } else if (value && typeof value === 'object' && value.value !== undefined) {
        displayValue = `${value.value} ${value.unit || ''}`.trim();
      } else {
        console.log('ProductDimensions: Unexpected value format for', key, ':', value);
        return; // Skip this dimension
      }
      
      html += `
        <div class="dimension-item">
          <span class="dimension-label">${dimensionLabels[key]}:</span>
          <span class="dimension-value">${displayValue}</span>
        </div>
      `;
    }
  });

  html += '</div>';
  console.log('ProductDimensions: Updating display with HTML');
  this.contentWrapper.innerHTML = html;
}

  getDimensionLabels() {
    return {
      length: this.container.dataset.labelLength || 'Länge',
      width: this.container.dataset.labelWidth || 'Breite',
      depth: this.container.dataset.labelDepth || 'Tiefe',
      height: this.container.dataset.labelHeight || 'Höhe',
      diameter: this.container.dataset.labelDiameter || 'Durchmesser'
    };
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductDimensions());
} else {
  new ProductDimensions();
}